import { createSelector } from 'reselect';

import { getState as getParent } from 'modules/dealerConfiguration/selectors';

const getState = createSelector(getParent, ({ sales }) => sales);

export const getUIState = createSelector(getState, ({ ui }) => ui ?? {});
export const getDataState = createSelector(getState, ({ data }) => data ?? {});
